import * as _ from 'lodash';
import React from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';

const ReportTopBarWidget = ({ rrReportsTab, selectedTab, setSelectedTab }) => {
  const renderTab = () =>
    _.map(rrReportsTab, (_tab) => (
      <Tab key={_tab} eventKey={_tab} title={_tab} className={'ds'}></Tab>
    ));

  const renderTabs = (
    <Col lg={12}>
      <Tabs
        defaultActiveKey={1}
        onSelect={(key) => setSelectedTab(key)}
        activeKey={selectedTab}
        id="tabs"
      >
        {renderTab()}
      </Tabs>
    </Col>
  );

  return (
    <Row style={{ marginTop: '5px' }}>
      <Col lg={12}>{renderTabs}</Col>
    </Row>
  );
};

export default ReportTopBarWidget;
